const c = {
  "cdr-card": "cdr-card_15-5-1"
};
export {
  c as default
};
